/* build/tpl */
import deps from './deps/exists.js';
import getExists from './getExists.js';
export default getExists(deps);
